import 'remixicon/fonts/remixicon.css';
import React from 'react';
import { userInfo } from 'os';
//import { useAppSelector } from '../../store/Hooks';
//import { StudentData } from '../../store/viewmodels/StudentViewModel';
//import { TeacherData } from '../../store/viewmodels/TeacherViewModel';

export interface PasswordModalProps {
    close: () => void;
}

function PasswordModal(props: PasswordModalProps) {

    //const studentData: StudentData = useAppSelector(state => state.studentData)
    //const teacherData: TeacherData = useAppSelector(state => state.teacherData)
    //const user = teacherData.isAuthenticated ? teacherData.teacher : studentData.student;

    const [oldpassword, setOldpassword] = React.useState("");
    const [newPassword, setNewPassword] = React.useState("");
    const [newPasswordAgain, setNewPasswordAgain] = React.useState("");
    const [errorMessage, setErrorMessage] = React.useState("");
    const [pswError, setPswError] = React.useState(<></>);
    const [oldPswError, setOldPswError] = React.useState(<></>);

    const handleChange = (event: any) => {
        switch (event.target.name) {
            case "newpsw": {
                setNewPassword(event.target.value);
                setPswError(<></>);
                setErrorMessage("");
                break;
            }
            case "oldpsw": {
                setOldpassword(event.target.value);
                setOldPswError(<></>);
                setErrorMessage("");
                break;
            }
            case "newpswAgain": {
                setNewPasswordAgain(event.target.value);
                setPswError(<></>);
                setErrorMessage("");
                break;
            }
            default: {
                break;
            }
        }
    }

    const handleSubmit = (event: any) => {
        if (newPassword !== newPasswordAgain) {
            setErrorMessage("Salasanat eivät täsmää.");
            setPswError(<label className={"ri-alert-line text-red-500 ml-2"}></label>);
        } else {
            setPswError(<></>);
        }

        if(oldpassword !== "") {
            //Todo, need to really check, if user has written rigth psw. 
            //Not good idea to do it here.
            setErrorMessage("Vanha salasana ei täsmää.");
            setOldPswError(<label className={"ri-alert-line text-red-500 ml-2"}></label>);
        }
        else {
            setOldPswError(<></>);
        }
    }

    let form: JSX.Element = (

        <form className="">
            <div className="mb-6">
                <div className="mb-2">
                    <label className="text-gray-500 font-bold">
                        Vanha salasana
                    </label>
                    {oldPswError}
                </div>
                <input className="
                    w-96 bg-gray-200 appearance-none 
                    border-2 border-gray-200 
                    rounded text-gray-700 leading-tight 
                    focus:outline-none focus:bg-white focus:border-teal-500"
                    id="oldpsw"
                    name="oldpsw"
                    type="password"
                    placeholder="vanha salasana"
                    value={oldpassword}
                    onChange={handleChange} />
            </div>
            <div>
                <div>
                    <div className="mb-2">
                        <label className="text-gray-500 font-bold">
                            Uusi salasana
                        </label>
                        {pswError}
                    </div>
                    <input className="
                    w-96 bg-gray-200 appearance-none 
                    border-2 border-gray-200 
                    rounded text-gray-700 leading-tight 
                    focus:outline-none focus:bg-white focus:border-teal-500"
                        id="newpsw"
                        name="newpsw"
                        type="password"
                        placeholder="uusi salasana"
                        value={newPassword}
                        onChange={handleChange} />
                </div>
                <div className="mt-2">
                    <div className="mb-2">
                        <label className="text-gray-500 font-bold mb-2">
                            Uusi salasana uudelleen
                        </label>
                        {pswError}
                    </div>
                    <input className="
                    w-96 bg-gray-200 appearance-none 
                    border-2 border-gray-200 
                    rounded text-gray-700 leading-tight 
                    focus:outline-none focus:bg-white focus:border-teal-500"
                        id="newpswAgain"
                        name="newpswAgain"
                        type="password"
                        placeholder="uusi salasana"
                        value={newPasswordAgain}
                        onChange={handleChange} />
                </div>
            </div>
            <div className="flex h-10">
                <div className="flex my-auto text-red-500">
                    <span className={"ri-alert-line " + errorMessage === "" ? "hidden" : ""}></span>
                    {errorMessage}
                </div>
            </div>
            <div className="">
                <div className="mt-4">
                    <button onClick={handleSubmit} className="border-transparent text-sm font-medium rounded-md text-white border-transparent bg-teal-600 hover:bg-teal-400 focus:shadow-outline text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500" type="button">
                        Tallenna
                    </button>
                    <button onClick={props.close} className="ml-2 border-transparent text-sm font-medium rounded-md text-white border-transparent bg-gray-500 hover:bg-gray-400 focus:shadow-outline text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500" type="button">
                        Peruuta
                    </button>
                </div>
            </div>
        </form>
    );

    return (
        <div className="w-96 m-8">
            <h2 className="mt-6 mb-6 text-center text-2xl font-extrabold text-gray-900">Muokkaa tietoja</h2>
            <div>{form}</div>
        </div>
    );
}

export default PasswordModal;